import { WrappedFieldProps } from 'redux-form';
import styled from 'styled-components';

import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import FormGroup from 'dashboard/layouts/FormLayout/FormGroup';
import ToggleSlider, { ToggleSliderProps } from 'design-system/components/ToggleSlider';

const StyledFormGroup = styled(FormGroup)`
  display: flex;
  flex-direction: column;
`;

export default (props: WrappedFieldProps & ToggleSliderProps & { label?: string }) => {
  const { input, meta, label, id, ...passthroughProps } = props;

  return (
    <StyledFormGroup className={props.className}>
      {label && <FormControlLabel htmlFor={id}>{label}</FormControlLabel>}
      <ToggleSlider {...input} {...passthroughProps} id={id} />
    </StyledFormGroup>
  );
};
